enum ReasonEnum {
	clickaway = 'clickaway'
}

export default ReasonEnum